import { apiConfig } from "./apiConfig";

export const brandApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getBrandList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
      }
    >({
      query: ({ startKey, page_size }) => ({
        url: `/v1/ap/admin/brand`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
        },
      }),
      providesTags: ["Brand"],
    }),

    createBrand: builder.mutation<any, any>({
      query: (body) => ({
        url: `/v1/ap/admin/brand`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Brand"],
    }),

    getSingleBrandDetails: builder.query<
      any,
      {
        brandId: string | null;
      }
    >({
      query: ({ brandId }) => ({
        url: `/v1/ap/admin/brand/${brandId}`,
      }),
    }),

    editBrand: builder.mutation<
      any,
      {
        brandId: string | null;
        body: any;
      }
    >({
      query: ({ brandId, body }) => ({
        url: `/v1/ap/admin/brand/${brandId}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["Brand"],
    }),
  }),
});

export const {
  useLazyGetBrandListQuery,
  useCreateBrandMutation,
  useLazyGetSingleBrandDetailsQuery,
  useEditBrandMutation,
} = brandApi;
